var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 9.99999C4.6875 9.0091 4.96051 8.08085 5.4348 7.28605V3.91464H2.0634C0.725313 5.65245 0 7.77038 0 9.99999C0 12.2296 0.725313 14.3475 2.0634 16.0853H5.4348V12.7139C4.96051 11.9191 4.6875 10.9909 4.6875 9.99999Z",
    fill: "#FBBD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.3125L7.65625 17.6562L10 20C12.2296 20 14.3475 19.2747 16.0854 17.9366V14.5688H12.7175C11.9158 15.0448 10.9836 15.3125 10 15.3125Z",
    fill: "#0F9D58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43439 12.714L2.06299 16.0854C2.32791 16.4294 2.61639 16.7589 2.92854 17.0711C4.81729 18.9598 7.3285 20 9.99959 20V15.3125C8.06115 15.3125 6.36221 14.2688 5.43439 12.714Z",
    fill: "#31AA52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 9.39161 19.9449 8.78208 19.8363 8.18841L19.7483 7.70798H10V12.3955H14.7442C14.2835 13.3119 13.5752 14.0596 12.7175 14.5688L16.0853 17.9367C16.4294 17.6717 16.7589 17.3833 17.0711 17.0711C18.9598 15.1823 20 12.6711 20 10Z",
    fill: "#3C79E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7565 6.24348L14.1708 6.65777L17.4854 3.34324L17.0711 2.92895C15.1823 1.0402 12.6711 0 10 0L7.65625 2.34375L10 4.6875C11.419 4.6875 12.7531 5.24008 13.7565 6.24348Z",
    fill: "#CF2D48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.6875V0C7.32902 0 4.81781 1.0402 2.92902 2.92891C2.61688 3.24105 2.3284 3.57055 2.06348 3.91465L5.43488 7.28605C6.36273 5.73125 8.06168 4.6875 10.0001 4.6875Z",
    fill: "#EB4132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7ec8164c04e316c4ae1516b5720114c3.svg";
export { ForwardRef as ReactComponent };